/**
 * Reine Logik des Venue-Reset (keine Browser-APIs → unit-testbar).
 * Die IO-Seite (IndexedDB wipen, Outbox drainen, Signale zurücksetzen) liegt in store.ts.
 */

/** kv-Marker: zu WELCHER Venue der lokale IndexedDB-Stand gehört (von config.ts unangetastet). */
export const STATE_VENUE_KEY = "stateVenueId";

export type VenueAction = "init" | "ok" | "switch";

/** Was beim Start zu tun ist: Marker fehlt → setzen; gleich → nichts; verschieden → Wechsel. */
export function venueAction(stateVenue: string | null | undefined, current: string): VenueAction {
  if (!stateVenue) return "init";
  return stateVenue === current ? "ok" : "switch";
}

/**
 * Welche kv-Schlüssel beim Venue-Wechsel gelöscht werden. Bewusst NICHT der Marker selbst
 * (wird danach neu gesetzt) und nichts Geräte-Eigenes (deviceId lebt ohnehin in localStorage).
 */
export function isVenueScopedKey(k: string): boolean {
  if (k === STATE_VENUE_KEY) return false;
  return (
    k.startsWith("menu:") ||
    k.startsWith("users:") ||
    k === "currentDraftId" ||
    k === "cloudFallback" ||
    k === "tablesConfig"
  );
}
